
import { defineComponent } from "vue";
import { IStudentsModel } from "@/interfaces/modules/aula/IStudentsModel";
import StudentsService from "@/api/Aula/StudentsService";
import store from "@/store";
import router from "@/router";


export default defineComponent({
  name: "App",
  data() {
    return {
      form: {
        loading: true,
        dialog: false,
        valid: false,
        record: {} as IStudentsModel,
        rules: {
          required: [(v: any) => !!v || "Este campo es requerido"],
        },
      },
      table: {
        filters: {
          search: "",
        },
        currentPage: 1,
        loading: false,
        headers: [
            {
            key: "SequenceNum",
            label: "# Registro único",
            sortable: true,
          },
          {
            key: "Name",
            label: "Nombre",
            sortable: true,
          },
          {
            key: "LastName",
            label: "Apellido",
            sortable: true,
          },
          {
            key: "IdentificationNumber",
            label: "Identificación",
            sortable: true,
          },
          {
            key: "PersonalEmail",
            label: "Email",
            sortable: true,
          },
          {
            key: "PrimaryPhone",
            label: "Teléfono",
            sortable: true,
          },
          {
            key: "Enable",
            label: "Activo",
            sortable: true,
          },

          {
            key: "CreatedByFormat",
            label: "Creación",
            sortable: true,
          },
          {
            key: "ModifiedByFormat",
            label: "Ultima modificación",
            sortable: true,
          },
          {
            key: "action",
            label: "Acciones",
            sortable: false,
          },
        ],
        records: [],
        rowsPerPage: 10,
      } as any,
    };
  },
  computed: {
    filteredItems(): any {
      return this.table.filters.search
        ? this.table.records.filter(
          (item: any) =>
            item.Name.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            ) ||
            item.LastName.toLowerCase().includes(
              this.table.filters.search.toLowerCase()
            )
        )
        : this.table.records;
    },
    formRecord(): any {
      return this.$refs.formRecord;
    },
    rows(): any {
      return this.table.records?.length || 0;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.table.loading = true;
      this.table.records = await StudentsService.GetStudents();
      this.table.loading = false;
    },
    async edit(Id: any) {
      router.push(`student-detail/${Id}`);

    },
    async newRecord() {
      router.push('student-detail/0');
    }
  },
});
